import React, { useState, useEffect } from 'react';

export enum StatusCode {
  success = 0,
  warning = 1,
  error = 2,
  info = 3,
  unauthorized = 4,
}

interface AlertProps {
  statusCode: StatusCode;
  message: string;
  duration?: number; // Optional: duration to show the alert in milliseconds
}

const Alert: React.FC<AlertProps> = ({ statusCode, message, duration = 10000 }) => {
  const [visible, setVisible] = useState<boolean>(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setVisible(false);
    }, duration);

    return () => clearTimeout(timer);
  }, [duration]);

  const getAlertColor = (statusCode: StatusCode) => {
    switch (statusCode) {
      case StatusCode.success:
        return 'success';
      case StatusCode.warning:
      case StatusCode.unauthorized:
        return 'warning';
      case StatusCode.error:
        return 'danger';
      case StatusCode.info:
        return 'info';
      default:
        return 'secondary';
    }
  };

  if (!visible) return null;

  const messages = message.split("\r\n");

  return (
    <div className={`alert alert-${getAlertColor(statusCode)} alert-dismissible fade show`} role="alert" onDoubleClick={() => setVisible(false)}>
      {messages.map((msg, index) => (
        <div key={index}>{msg}</div>
      ))}
      <button type="button" className="btn-close" onClick={() => { setVisible(false) }} aria-label="Close"></button>
    </div>
  );
};

export default Alert;
